<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="top-box">
        <p class="p1">{{ model.companyFullName }}</p>
        <p class="p2">{{ dateTime }}</p>
      </div>

      <div class="content-box" style="padding-top: 20px">
        <el-row :gutter="20">
          <el-col :span="8" :xs="24" style="position: absolute; left: 0">
            <el-card>
              <div class="title-box">
                <ul>
                  <li>编号：{{ model.cabinetCode }}</li>
                  <li>标签：{{ model.cabinetName }}</li>
                  <li>型号：{{ model.modelName }}</li>
                  <li v-if="model.state == 1">状态：停机</li>
                  <li v-else-if="model.state == 3">状态：故障</li>
                  <li v-else-if="model.state == 4">状态：充电中</li>
                  <li v-else-if="model.state == 5">状态：放电中</li>
                  <li v-else>状态：空闲</li>
                  <li>电量：{{ model.soc }} %</li>
                  <li>温度：{{ model.temp }} ℃</li>
                </ul>
              </div>
            </el-card>

            <el-card class="map-box">
              <el-amap
                vid="amap"
                :zoom="zoom"
                :center="center"
                :events="mapEvents"
              >
                <el-amap-marker
                  v-for="marker in markers"
                  :position="marker.position"
                  :key="marker.id"
                >
                </el-amap-marker>
              </el-amap>
            </el-card>

            <el-card class="table-card">
              <div
                style="
                  padding-top: 12px;
                  font-size: 14px;
                  padding-left: 10px;
                  font-weight: bold;
                "
              >
                报警信息
              </div>
              <el-table
                v-loading="loading"
                :data="alarmList"
                stripe
                class="table-list"
              >
                <el-table-column label="设备编号">
                  <template slot-scope="scope">
                    {{ scope.row.cabinetCode }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="alarmCodeName"
                  label="报警名称"
                ></el-table-column>

                <el-table-column
                  prop="alarmCode"
                  label="故障代码"
                  align="center"
                ></el-table-column>

                <el-table-column
                  prop="gmtCreate"
                  label="时间"
                  align="center"
                ></el-table-column>
              </el-table>
            </el-card>
          </el-col>
          <el-col :span="16" :xs="24" style="position: absolute; right: 0">
            <el-card>
              <div class="ibtn-box">
                <div
                  id="dailyChart"
                  style="height: 282px; margin-top: 20px"
                ></div>
              </div>
            </el-card>

            <el-card class="table-card" style="margin-top: 10px">
              <div
                style="
                  padding-top: 12px;
                  font-size: 14px;
                  padding-left: 10px;
                  font-weight: bold;
                "
              >
                充放订单
              </div>
              <el-table
                v-loading="loading"
                :data="listData"
                stripe
                class="table-list"
              >
                <el-table-column
                  prop="cabinetCode"
                  label="设备编号"
                ></el-table-column>
                <el-table-column label="状态" align="center" width="90">
                  <template slot-scope="scope">
                    <el-span v-if="scope.row.chargeType == 1">充电</el-span>
                    <el-span v-else-if="scope.row.chargeType == 2"
                      >放电</el-span
                    >
                    <el-span v-else>空闲</el-span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="chargePower"
                  align="center"
                  label="充电量(度)"
                >
                  <template slot-scope="scope">
                    <span class="nowrap">{{ scope.row.chargePower }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="dischargePower"
                  align="center"
                  label="放电量(度)"
                >
                  <template slot-scope="scope">
                    <span class="nowrap">{{ scope.row.dischargePower }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="profit" align="center" label="收益(元)">
                  <template slot-scope="scope">
                    <span class="nowrap">{{ scope.row.profit }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="开始时间" align="center">
                  <template slot-scope="scope">
                    <span class="nowrap">{{ scope.row.startTime }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="结束时间" align="center">
                  <template slot-scope="scope">
                    <span class="nowrap">{{ scope.row.endTime }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import VueAMap from "vue-amap";
//地图
VueAMap.initAMapApiLoader({
  key: "YOUR_KEY",
  plugin: [
    "Autocomplete",
    "PlaceSearch",
    "Scale",
    "OverView",
    "ToolBar",
    "MapType",
    "PolyEditor",
    "AMap.CircleEditor",
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: "1.4.4",
});

import * as echarts from "echarts"; //eslint-disable-line no-unused-vars
// import "echarts/map/js/china"; // 引入中国地图数据
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
export default {
  data() {
    return {
      dateTime: "",
      loading: false,
      alarmList: [], //报警
      listData: [], //充放记录
      dailyData: null, //日统计
      echartList: [],
      zoom: 16, //初始化地图显示层级
      center: [114.057922, 22.543518], //地图中心点坐标
      markers: [
        {
          position: [114.057922, 22.543518],
        },
      ],
      mapEvents: {
        init(o) {
          //console.log(o.getCenter());
        },
        zoomchange: (e) => {
          //console.log(e);
        },
        zoomend: (e) => {
          //获取当前缩放zoom值
          //console.log(e);
        },
        click: (e) => {},
      },
      model: {
        gmtCreate: "2022-02-18 18:09:01",
        createdBy: "",
        modifiedBy: "",
        gmtModified: "2022-02-28 15:48:50",
        id: "",
        companyId: "",
        cabinetCode: "",
        cabinetName: "",
        svrIp: null,
        svrPort: null,
        passwd: null,
        lng: 114.044618,
        lat: 22.544489,
        address: null,
        auditTime: null,
        auditor: null,
        remark: null,
        softVer: null,
        commVer: null,
        power: null,
        faultCode: null,
        feeConfigId: null,
        modelId: "",
        companyName: "",
        companyFullName: "",
        modelName: "",
        soc: null,
        temp: null,
        state: -1,
        online: 0,
        orderBy: null,
      },
    };
  },
  mounted() {},
  methods: {
    initDataOther: function () {
      let _this = this;
      let id = _this.$route.query.id || "";

      AxiosAjax({
        url:
          "/cabinet/monitoring/orders?companyId=" +
          _this.model.companyId +
          "&cabinetId=" +
          id +
          "&size=9",
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });

      AxiosAjax({
        url:
          "/cabinet/monitoring/alarms?companyId=" +
          _this.model.companyId +
          "&cabinetId=" +
          id +
          "&size=2",
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.alarmList = res.data.data;
        },
        error: function (err) {
          _this.alarmList = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });

      var _dateFrom = addDate(new Date(), -5);
      var _dateTo = addDate(new Date(), 0);

      //日统计
      AxiosAjax({
        url:
          "/cabinet/monitoring/dailyStats?companyId=" +
          _this.model.companyId +
          "&cabinetId=" +
          id +
          "&dateFrom=" +
          _dateFrom +
          "&dateTo=" +
          _dateTo,
        success: function (res) {
          _this.dailyData = res.data.data;
          _this.initChart();
        },
      });
    },
    //加载数据
    initData: function () {
      let _this = this;
      let id = _this.$route.query.id || "";

      AxiosAjax({
        url: "/cabinet/monitoring/cabinet?cabinetId=" + id,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.model = res.data.data;
          _this.center = [_this.model.lng, _this.model.lat]; //地图中心点坐标
          _this.markers = [
            {
              position: [_this.model.lng, _this.model.lat],
            },
          ];

          _this.initDataOther();
        },
        error: function (err) {},
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //跳转链接
    linkUrl: function (url) {
      window.location.href = url;
    },
    //初始化图表
    initChart: function () {
      let titleDaily = [];

      let dataChargePower = []; //充
      let dataDischargePower = []; //放
      let dataExpenditure = []; //
      let dataIncome = []; //
      let dataProfit = []; //

      this.dailyData.map((item) => {
        titleDaily.push(item.date);
        dataChargePower.push(item.chargePower);
        dataDischargePower.push(item.dischargePower);
        dataExpenditure.push(item.expenditure);
        dataIncome.push(item.income);
        dataProfit.push(item.profit);
      });

      //基于准备好的dom，初始化echarts实例
      let dailyChart = echarts.init(document.getElementById("dailyChart"));

      this.echartList.push(dailyChart);

      var optionDaily = {
        color: ["#3398DB"],
        title: {
          text: "日统计数据",
          subtext: "",
          textStyle: {
            fontSize: 16,
            fontWeight: "normal",
            color: "#000",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: titleDaily,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "充电",
            type: "line",
            data: dataChargePower,
            itemStyle: {
              normal: {
                color: "#00aa00", //改变折线点的颜色
                lineStyle: {
                  color: "#00aa00", //改变折线颜色
                },
              },
            },
          },
          {
            name: "放电",
            type: "line",
            data: dataDischargePower,
            itemStyle: {
              normal: {
                color: "#0055ff", //改变折线点的颜色
                lineStyle: {
                  color: "#0055ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "成本",
            type: "line",
            data: dataExpenditure,
            itemStyle: {
              normal: {
                color: "#5555ff", //改变折线点的颜色
                lineStyle: {
                  color: "#5555ff", //改变折线颜色
                },
              },
            },
          },
          {
            name: "收入",
            type: "line",
            data: dataIncome,
            itemStyle: {
              normal: {
                color: "#555500", //改变折线点的颜色
                lineStyle: {
                  color: "#555500", //改变折线颜色
                },
              },
            },
          },
          {
            name: "利润",
            type: "line",
            data: dataProfit,
            itemStyle: {
              normal: {
                color: "#ff0000", //改变折线点的颜色
                lineStyle: {
                  color: "#ff0000", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      //绘制图表
      dailyChart.setOption(optionDaily);
    },
  },
  created: function () {
    var _this = this;

    //加载数据
    _this.initData();

    window.setInterval(function () {
      _this.dateTime = new Date(new Date()).pattern("yyyy-MM-dd HH:mm:ss");
    }, 1000);
  },
};
</script>
<style scoped>
.top-box {
  height: 30px;
  line-height: 50px;
  padding: 0 20px;
  font-size: 20px;
}
.top-box .p1 {
  float: left;
  padding-left: 10px;
}
.top-box .p2 {
  float: right;
  padding-right: 10px;
}
.title-box ul li {
  font-size: 24px;
  padding: 8px;
}
.map-box {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 310px;
}
.map-box .el-card__body {
  height: 100%;
  padding: initial;
}
</style>


// WEBPACK FOOTER //
// src/components/Monitor/CabinetShow.vue